import React from 'react';
import i18next from 'i18next';
import MediaQuery from 'react-responsive';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import HeaderUser from '../HeaderUser/HeaderUser';
import Icon from '../Icon/Icon';
import { ModalsConsumer } from '../Modal/ModalsProvider';
import SignInForm from '../Form/SignInForm';
import { hideMenu, showMenu } from '../../actions/appActions';
import personWhite from 'icons/person-white.svg';
import logoutIcon from 'icons/logout.svg';
import logo from 'icons/logo.svg';
import SignUpForm from '../Form/SignUpForm';
import Hamburger from '../Hamburger/Hamburger';
import SocIcons from '../SocIcons/SocIcons';
import Wallet from '../Wallet/Wallet';

import walletIcon from 'icons/wallet.svg';
import ru from '../../../locales/ru.json';
import en from '../../../locales/en.json';

class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      animBalance: false,
    };
  }


  componentDidUpdate(prevProps) {
    if (prevProps.balance && prevProps.balance !== this.props.balance) {
      this.setState({ animBalance: this.props.balance - prevProps.balance });
    }
  }




  toggleMenu = () => {
    this.props.isMenuVisible ? this.props.hideMenu() : this.props.showMenu();
  };

  renderNav() {
    const { profile} = this.props;

    return (
      <div className="header__nav">
        <MediaQuery query="(max-width: 959px)">
          {profile && this.renderWallet('nav')}
        </MediaQuery>
        <NavLink to="/terms" className="link link--white header__link" >
          {i18next.t('header.locales')}
        </NavLink>
        <NavLink to="/terms" className="link link--white header__link">
          {i18next.t('header.rules')}
        </NavLink>

        <NavLink to="/faq" className="link link--white header__link">
          {i18next.t('header.faq')}
        </NavLink>

        <div className="header__socials">
          <SocIcons />
        </div>
      </div>
    );
  }

  renderWallet(dest) {
    return (
      <NavLink
        to="/wallet"
        className={
          dest === 'header'
            ? 'header__wallet header__wallet--header'
            : 'header__wallet header__wallet--nav link link--white header__link'
        }
      >
        <Icon glyph={walletIcon} />
        <span>{i18next.t('header.wallet')}</span>
      </NavLink>
    );
  }

  renderMobileMenu() {
    const { isMenuVisible } = this.props;

    return (
      <div
        className={'header__mobile-menu' + (isMenuVisible ? ' is-opened' : '')}
      >
        {this.renderNav()}
      </div>
    );
  }

  render() {
    const { animBalance } = this.state;
    const { isLoading, profile, balance, isMenuVisible } = this.props;

    return (
      <header className={'header' + (!profile ? ' header--guest' : '')}>
        <MediaQuery query="(max-width: 959px)">
          {this.renderMobileMenu()}
        </MediaQuery>

        <header className="header__inner">
          <div className="header__left">
            <MediaQuery query="(max-width: 959px)">
              <Hamburger isActive={isMenuVisible} onClick={this.toggleMenu} />
            </MediaQuery>

            <a href="#" className="header__logo logo">
              <Icon glyph={logo} />
            </a>
          </div>

          <MediaQuery query="(min-width: 960px)">{this.renderNav()}</MediaQuery>

          <div className="header__right">
            <MediaQuery query="(min-width: 500px)">
              {profile && this.renderWallet('header')}
            </MediaQuery>

            {profile && (
              <Link to="/wallet" className="header__user-block">
                <HeaderUser profile={profile} balance={balance} />
                {animBalance > 0 && (
                  <div className="header__anim-balance" key={animBalance}>
                    <span>+{animBalance} REX</span>
                  </div>
                )}
              </Link>
            )}

            {!(isLoading || profile) && (
              <ModalsConsumer>
                {({ showModal }) => (
                  <React.Fragment>
                    <div className="text-icon header__link ">
                      <Icon className="text-icon__icon" glyph={personWhite} />
                      <div
                        className="link link--white"
                        onClick={() => showModal(<SignInForm />)}
                      >
                        {i18next.t('header.sign_in')}
                      </div>
                    </div>
                    <div
                      className="header__user-block"
                      onClick={() => showModal(<SignUpForm />)}
                    >
                      <div className="text-icon header__logout">
                        <Icon className="text-icon__icon" glyph={logoutIcon} />
                        {i18next.t('header.sign_up')}
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </ModalsConsumer>
            )}
          </div>
        </header>
      </header>
    );
  }
}

export default connect(
  (state) => {
    return {
      isMenuVisible: state.app.isMenuVisible,
      isLoading: state.user.isLoading,
      profile: state.user.profile,
      balance: state.user.balance,
      pathname: state.router.location.pathname,
    };
  },
  {
    showMenu,
    hideMenu,
  }
)(Header);



// WEBPACK FOOTER //
// ./app/components/Header/Header.jsx